import { ColumnTypes, FilterTypes } from "commons/table/Constants";
import { formatDateWithTime } from "services/MomentUtils";

export const UFL_PROGRAM_TYPE_LIST_COLUMNS = (handlePriorityClick) => [
  {
    header: "Fax Program",
    accessor: "faxProgramTypeName",
    accessorKey: "faxProgramTypeName",
    columnType: ColumnTypes.Text,
    width: 300,
    enableSorting: true,
    enableColumnFilter: true,
    filterType: FilterTypes.SearchableInput,
  },
  {
    header: "Fax Count",
    accessor: "faxCount",
    accessorKey: "faxCount",
    columnType: ColumnTypes.Text,
    width: 25,
    enableSorting: true,
  },
  {
    header: "Priority (Total)",
    accessor: "totalPriorityFaxCount",
    accessorKey: "totalPriorityFaxCount",
    width: 100,
    columnType: ColumnTypes.Custom,
    customComponent: (value, row) => {
      const priorityCount = row.original.totalPriorityFaxCount;
      const faxCount = row.original.faxCount;
      if (faxCount === 0) {
        return <span>N/A</span>;
      }
      if (priorityCount && priorityCount > 0) {
        return (
          <div style={{ display: "flex", alignItems: "baseline", gap: "5px" }}>
            <p style={{ margin: 0 }}>
              {priorityCount} {priorityCount === 1 ? "Fax" : "Faxes"}
            </p>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handlePriorityClick(row);
              }}
            >
              Click to View
            </a>
          </div>
        );
      }
      return <p style={{ margin: 0 }}>{priorityCount || 0} Faxes</p>;
    },
    enableSorting: true,
  },
  {
    header: "Date Received",
    accessor: "dateReceived",
    accessorKey: "dateReceived",
    columnType: ColumnTypes.Custom,
    width: 100,
    enableSorting: true,
    customComponent: (value, row) => {
      const faxCount = row.original.faxCount;
      if (faxCount === 0) {
        return <span>N/A</span>;
      }
      return <span>{formatDateWithTime(value)}</span>;
    },
  },
];

export const UFL_PROGRAM_TYPE_MODAL_COLUMNS = () => [
  {
    header: "Priority Tag Type",
    accessor: "priority",
    accessorKey: "priority",
    columnType: ColumnTypes.Text,
    width: 100,
    enableSorting: true,
  },
  {
    header: "Fax Count",
    accessor: "count",
    accessorKey: "count",
    width: 50,
    columnType: ColumnTypes.Text,
    enableSorting: true,
  },
];

export const RESPONSE_PROGRAM_TYPE_LIST_COLUMNS = () => [
  {
    header: "Fax Program",
    accessor: "faxProgramTypeName",
    accessorKey: "faxProgramTypeName",
    columnType: ColumnTypes.Text,
    width: 300,
    enableSorting: true,
    enableColumnFilter: true,
    filterType: FilterTypes.SearchableInput,
  },
  {
    header: "Fax Count",
    accessor: "rawCount",
    accessorKey: "rawCount",
    columnType: ColumnTypes.Text,
    width: 25,
    enableSorting: true,
  },
  {
    header: "Date Received",
    accessor: "dateReceived",
    accessorKey: "dateReceived",
    columnType: ColumnTypes.Custom,
    width: 100,
    enableSorting: true,
    customComponent: (value, row) => {
      const rawCount = row.original.rawCount;
      if (rawCount === 0) {
        return <span>N/A</span>;
      }
      return <span>{formatDateWithTime(value)}</span>;
    },
  },
];

export const TRANSCRIBER_PROGRAM_TYPE_LIST_COLUMNS = () => [
  {
    header: "Fax Program",
    accessor: "faxProgramTypeName",
    accessorKey: "faxProgramTypeName",
    columnType: ColumnTypes.Text,
    width: 300,
    enableSorting: true,
    enableColumnFilter: true,
    filterType: FilterTypes.SearchableInput,
  },
  {
    header: "Fax Count",
    accessor: "faxCount",
    accessorKey: "faxCount",
    columnType: ColumnTypes.Text,
    width: 25,
    enableSorting: true,
  },
  {
    header: "Date Received",
    accessor: "dateReceived",
    accessorKey: "dateReceived",
    columnType: ColumnTypes.Custom,
    width: 100,
    enableSorting: true,
    customComponent: (value, row) => {
      const faxCount = row.original.faxCount;
      if (faxCount === 0) {
        return <span>N/A</span>;
      }
      return <span>{formatDateWithTime(value)}</span>;
    },
  },
];
